
import { mapState } from 'vuex'

export const globalMixin = {
  computed: {
    ...mapState('d2admin/menu', {
      $adminMenu: 'admin',
      $projectMenu: 'project',
      $perMenu: 'per'
    }),
    $projectPlugins () {
      let pPlugins = []
      if (this.$projectMenu) {
        this.$projectMenu.forEach(function (p) {
          pPlugins.push(p.id)
        })
      }
      return pPlugins
    },
    $projectModules () {
      let pModules = []
      if (this.$projectMenu) {
        this.$projectMenu.forEach(function (p) {
          if (p.childrenList && p.childrenList.length > 0) {
            p.childrenList.forEach(function (m) {
              pModules.push(m.id)
            })
          }
        })
      }
      return pModules
    },
    $projectActions () {
      let pActions = []
      if (this.$projectMenu) {
        this.$projectMenu.forEach(function (p) {
          p.childrenList.forEach(function (m) {
            m.childrenList.forEach(function (a) {
              pActions.push(a.id)
            })
          })
        })
      }
      return pActions
    },
    $adminPlugins () {
      let aPlugins = []
      if (this.$adminMenu) {
        this.$adminMenu.forEach(function (p) {
          aPlugins.push(p.id)
        })
      }
      return aPlugins
    },
    $adminModules () {
      let aModules = []
      if (this.$adminMenu) {
        this.$adminMenu.forEach(function (p) {
          p.childrenList.forEach(function (m) {
            aModules.push(m.id)
          })
        })
      }
      return aModules
    },
    $adminActions () {
      let aActions = []
      if (this.$adminMenu) {
        this.$adminMenu.forEach(function (p) {
          p.childrenList.forEach(function (m) {
            m.childrenList.forEach(function (a) {
              aActions.push(a.id)
            })
          })
        })
      }
      return aActions
    },
    $perPlugins () {
      let pPlugins = []
      if (this.$perMenu) {
        this.$perMenu.forEach(function (p) {
          pPlugins.push(p.id)
        })
      }
      return pPlugins
    },
    $perModules () {
      let pModules = []
      if (this.$perMenu) {
        this.$perMenu.forEach(function (p) {
          p.childrenList.forEach(function (m) {
            pModules.push(m.id)
          })
        })
      }
      return pModules
    },
    $perActions () {
      let pActions = []
      if (this.$perMenu) {
        this.$perMenu.forEach(function (p) {
          p.childrenList.forEach(function (m) {
            m.childrenList.forEach(function (a) {
              pActions.push(a.id)
            })
          })
        })
      }
      return pActions
    }
  },
  methods: {
    $checkAdminPlugin (pid) {
      return this.$adminPlugins.indexOf(pid) > -1
    },
    $checkAdminModule (mid) {
      return this.$adminModules.indexOf(mid) > -1
    },
    $checkAdminAction (aid) {
      return this.$adminActions.indexOf(aid) > -1
    },
    $checkProjectPlugin (pid) {
      return this.$projectPlugins.indexOf(pid) > -1
    },
    $checkProjectModule (mid) {
      return this.$projectModules.indexOf(mid) > -1
    },
    $checkProjectAction (aid) {
      return this.$projectActions.indexOf(aid) > -1
    },
    $checkPerPlugin (pid) {
      return this.$perPlugins.indexOf(pid) > -1
    },
    $checkPerModule (mid) {
      return this.$perModules.indexOf(mid) > -1
    },
    $checkPerAction (aid) {
      return this.$perActions.indexOf(aid) > -1
    }
  }
}
